export default "__VITE_ASSET__4cefbab6__"